<template>
  <div class="row">
    <v-layout row wrap>
      <v-flex lg4 md6 sm12 xs12>
        <v-container>
          <v-card flat>
            <v-card-title
              ><h4 class="earth-color">Update Booking Alert</h4></v-card-title
            >
            <v-container>
              <v-form @submit.prevent="saveAlertUpdate()">
                <v-text-field
                  v-model="updated.created_at"
                  label="Date Alerted"
                  readonly
                  persistent-hint
                ></v-text-field>
                <v-text-field
                  label="Alert"
                  v-model="updated.note"
                  readonly
                ></v-text-field>
                <v-text-field
                  v-if="ranger_note == 2"
                  label="Booking ref"
                  v-model="updated.booking_ref"
                ></v-text-field>
                <v-textarea
                  label="Action Taken"
                  v-model="updated.update_note"
                ></v-textarea>

                <v-btn
                  :depressed="true"
                  color="primary"
                  block
                  type="submit"
                  :loading="$loadingTrue"
                  >Add</v-btn
                >
              </v-form>
            </v-container>
          </v-card>
				<v-container>
          <v-btn
            :depressed="true"
            fab
            round
            small
            @click="back()"
            color="primary"
            ><v-icon>navigate_before</v-icon></v-btn
          >
					</v-container>

        </v-container>
      </v-flex>
      <v-flex lg8 md6 sm12 xs12>
        <v-card flat>
          <v-card-title>
            <h4 class="earth-color">ACTION TAKEN</h4>
            <v-spacer></v-spacer>
            <v-text-field
              append-icon="search"
              text="Search"
              single-line
              hide-details
              v-model="search"
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="columns"
            :items="getAlertNote"
            :search="search"
            :rows-per-page-items="[10, 25, { text: 'All', value: -1 }]"
            :disable-initial-sort="true"
            :loading="$loadingTrue"
          >
            <v-progress-linear
              slot="progress"
              color="primary"
              indeterminate
            ></v-progress-linear>
            <template slot="items" slot-scope="props">
              <td class="fancy">{{ props.item.note }}</td>
              
              <td class="fancy" style="text-transform: capitalize">
                <router-link
                  :to="{
                    name: 'Booking',
                    params: { booking_id: props.item.booking_public_id },
                  }"
                  target="_blank"
                >
                  <a class="text-dark">
                    <u>{{ props.item.booking_ref_code }}</u>
                  </a>
                </router-link>
              </td>
              <td class="fancy">{{ props.item.session_user }}</td>
              <td class="fancy">
                {{ formated_date_time(props.item.created_at) }}
              </td>
            </template>
            <v-alert
              slot="no-results"
              :value="true"
              color="error"
              icon="warning"
            >
              Your search for "{{ search }}" found no results.
            </v-alert>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: "view-update-alert",
  data() {
    return {
      requiredRules: [(v) => !!v || "This field is required"],
      search: "",
      ranger_note: 0,
      columns: [
        {
          text: "Action Taken",
          value: "alert_update",
        },
        {
          text: "Booking Ref",
          value: "booking_ref",
        },
        {
          text: "Taken By",
          value: "session_user",
        },
        {
          text: "Taken At",
          value: "created_at",
        },
      ],
      updated: {
        created_at: "",
        note: "",
        note_public_id: "",
        booking_public_id: "",
        booking_ref: "",
        // ranger_note:0,
      },
    };
  },
  created() {
    this.$store.dispatch("get_alerted_note", this.$route.params.note_id);
  },
  computed: {
    getAlertNote: function () {
      let single_note = this.$store.state.NoteStore.alerted_note;
      if (single_note.length > 0) {
        let single_note_obj = single_note[0];
        this.updated.created_at = this.$moment(
          single_note_obj.created_at
        ).format("YYYY-MM-DD");
        this.ranger_note = single_note_obj.ranger_note;
        this.updated.note = single_note_obj.note;
        this.updated.note_public_id = single_note_obj.note_public_id;
        this.updated.booking_public_id = single_note_obj.booking_id;
        // this.updated.ranger_note = single_note_obj.ranger_note;

        return this.$store.state.NoteStore.alerted_note[0].update_notes;
      }
    },
  },
  methods: {
    saveAlertUpdate: function () {
      if (this.ranger_note == 2) {
        this.$store.dispatch("update_unticketedranger_note", this.updated);
      } else {
        this.$store.dispatch("update_ranger_note", this.updated);
      }
  
    },
		 back: function () {
      return this.$router.back()
    },
  },
};
</script>

<style scoped>
</style>
